import { render, staticRenderFns } from "./SeparationAnxietyCard.vue?vue&type=template&id=77c8abc8&scoped=true&"
import script from "./SeparationAnxietyCard.vue?vue&type=script&lang=js&"
export * from "./SeparationAnxietyCard.vue?vue&type=script&lang=js&"
import style0 from "./SeparationAnxietyCard.vue?vue&type=style&index=0&id=77c8abc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c8abc8",
  null
  
)

export default component.exports